const CURRENCY = {
  'EUR': '€'
};

const getSymbolCurrency = cur => CURRENCY[cur];

export default getSymbolCurrency;
